import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";

import { Button, Input } from "components";

import VanLogo from "assets/images/img-vanbora-logo.png";
import StringHelper from "helpers/string-helper";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { getPartnerUuid, partnerLogin } from "services/auth";
import { setFirstAcess } from "store/features/flags/slice";
import { resetRegistration } from "store/features/registration/slice";
import { setPartnerUuid, setUserId } from "store/features/tokens/slice";
import { SelfRegisterTokens } from "store/features/tokens/types";
import styles from "./styles.module.scss";

const SignInSchema = Yup.object().shape({
	email: Yup.string()
		.required("Campo obrigatório")
		.test(
			"is-email-or-phone",
			"Campo inválido",
			(value) =>
				!!value &&
				(/^\(?\d{2}\)? ?\d{4,5}-?\d{4} *$/.test(value) ||
					/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
		),
	password: Yup.string().required("Campo obrigatório")
});

export default function LoginPage() {
	const [submitting, setSubmitting] = useState<boolean>(false);
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const formik = useFormik({
		initialValues: {
			email: "",
			password: ""
		},
		validationSchema: SignInSchema,
		onSubmit: async (values) => {
			setSubmitting(true);
			dispatch(resetRegistration());

			if (/^\(?\d{2}\)? ?\d{4,5}-?\d{4} *$/.test(values.email))
				values.email = StringHelper.sanitizeString(values.email);

			await partnerLogin(values.email, values.password)
				.then(async (account) => {
					if (account) {
						setSubmitting(false);
						const accountData = account as SelfRegisterTokens;
						dispatch(setUserId(accountData.user_id));

						await getPartnerUuid().then(async (uuid) => {
							if (uuid) {
								dispatch(setFirstAcess(uuid === ""));
								dispatch(setPartnerUuid(uuid as string));
								navigate("/home");
							} else {
								dispatch(setFirstAcess(true));
								dispatch(setPartnerUuid(""));
								navigate("/cadastro/informacoes-pessoais");
							}
						});
					}
				})
				.catch((error) => {
					setSubmitting(false);
					const message =
						error.message === "Prestador não encontrado"
							? error.message
							: "Algo saiu errado, tente novamente";

					toast.error(message, {
						position: "bottom-center",
						autoClose: 5000,
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "light"
					});
				});
		}
	});

	return (
		<div className={styles.container}>
			<div className={styles.loginHeader}>
				<img src={VanLogo} alt="" />
				<span>Parceiros</span>
			</div>
			<div className={styles.loginMessage}>
				<span>Acesse a sua conta</span>
				<span>Entre com as suas credenciais para continuar</span>
			</div>
			<form onSubmit={formik.handleSubmit}>
				<div className={styles.loginContainer}>
					<Input
						id="email"
						name="email"
						placeholder="Digite seu número ou e-mail"
						label="Número do celular ou e-mail"
						value={formik.values.email || ""}
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
						error={formik.touched.email && formik.errors.email}
						errorMessage={formik.errors.email}
					/>
					<div className="w-full text-right">
						<Input
							id="password"
							name="password"
							placeholder="Digite sua senha"
							label="Senha"
							type="password"
							value={formik.values.password}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							error={formik.touched.password && formik.errors.password}
						/>
					</div>

					<Button
						type="submit"
						disabled={!formik.isValid || !formik.dirty || submitting}
					>
						{/* {submitting ? <Loading size="small" /> : "Entrar"} */}
						Entrar
					</Button>

					<div className="flex justify-center">
						<Button
							className="mt-2 p-0 h-6 w-fit"
							type="button"
							variant="text"
							onClick={() => navigate("/reenviar-senha")}
						>
							Esqueci minha senha
						</Button>
					</div>

					<div className="w-full mx-auto">
						<div className={styles.loginDivider}>
							<span>ou</span>
						</div>

						<Button
							type="button"
							variant="outline"
							onClick={() => navigate("/cadastro/informacoes-pessoais")}
						>
							Ainda não tenho uma conta
						</Button>
					</div>
				</div>
			</form>
		</div>
	);
}
